<template>
    <div class="top-bar">
        <div class="container">
            <div class="row d-flex align-items-center justify-content-between">
                <div class="col-6 d-none d-md-block h-100 p-0">
                    <ul class="top-bar__phones">
                        <li><i class="icon-headset"></i></li>
                        <li><a href="tel:+38 (044) 353-94-50">+38 (044) 353-94-50</a></li>
                        <li class="d-none d-lg-inline"><a href="tel:+38 (068) 982-49-60">+38 (068) 982-49-60</a></li>
                    </ul>
                </div>
                <div class="col-12 col-md-6 h-100 p-0">
                    <ul class="top-bar__buttons text-center text-md-right">
                        <li class="pr-3 pl-3 pr-md-0 float-left float-md-none">
                            <a target="_blank" href="http://air.prosto.net/" class="btn btn-sm btn-outline-light font-weight-bold">
                                Демонстрація системи
                            </a>
                        </li>
                        <li class="px-3 float-right float-md-none">
                            <button id="open-modal" class="btn btn-sm btn-light font-weight-bold">
                                Замовити консультацію
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopBar"
    }
</script>

<style scoped>

</style>